/* global Promise */
'use strict';

var commons = require('../../../commons/httpClient');
var httpClient = commons.httpClient;
var store = require('adyen_config/store');
var helpers = require('../../../checkout/helpers');
var constants = require('adyen_config/constants');
var PAYPAL = constants.PAYPAL;
var initCheckout = require('../../initializeCheckout');
var initializeCheckout = initCheckout.initializeCheckout;
var adyenCommons = require('../../../commons');
var createTemporaryBasket = adyenCommons.createTemporaryBasket;

function Paypal(config, applicationInfo, isExpressPdp, initialAmount) {
    var paypalReviewPageEnabled = window.paypalReviewPageEnabled;
    var returnURL = window.returnURL;
    var basketAmount = window.basketAmount;
    var makeExpressPaymentsCall = window.makeExpressPaymentsCall;
    var saveShopperData = window.saveShopperData;
    var makeExpressPaymentDetailsCall = window.makeExpressPaymentDetailsCall;
    var showConfirmationAction = window.showConfirmationAction;
    var shippingMethodsUrl = window.shippingMethodsUrl;
    var selectShippingMethodUrl = window.selectShippingMethodUrl;
    var saveExpressPaymentDataUrl = window.saveExpressPaymentDataUrl;

    this.store = store;
    this.helpers = helpers;
    this.returnUrl = returnURL;
    this.amount = initialAmount || JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.isExpressPdp = isExpressPdp;
    this.userAction = paypalReviewPageEnabled ? 'continue' : null;
    this.makeExpressPaymentsCallUrl = makeExpressPaymentsCall;
    this.saveShopperDataUrl = saveShopperData;
    this.makeExpressPaymentDetailsCallUrl = makeExpressPaymentDetailsCall;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.saveExpressPaymentDataUrl = saveExpressPaymentDataUrl;
    this.applicationInfo = applicationInfo;
    this.config = config;
}

Paypal.updateComponent = function (response, component) {
    if (response) {
        var paymentData = response.paymentData;
        var status = response.status;
        var errorMessage = response.errorMessage || '';
        if (!paymentData || status !== 'success') {
            throw new Error(errorMessage);
        }
        component.updatePaymentData(paymentData);
    } else {
        throw new Error('No response');
    }
    return false;
};

Paypal.onError = function () {
    if ($.spinner) {
        $.spinner().stop();
    }
};

Paypal.prototype.callPaymentFromComponent = function (state, component) {
    var self = this;
    try {
        if ($.spinner) {
            $.spinner().start();
        }

        var basketPromise = Promise.resolve({ temporaryBasketCreated: true });
        if (this.isExpressPdp) {
            basketPromise = createTemporaryBasket();
        }

        basketPromise.then(function (tempBasketResponse) {
            if (!tempBasketResponse || !tempBasketResponse.temporaryBasketCreated) {
                component.handleError(new Error('Failed to create temporary basket'));
                return;
            }

            httpClient({
                method: 'POST',
                url: self.makeExpressPaymentsCallUrl,
                data: {
                    csrf_token: $('#adyen-token').val(),
                    data: JSON.stringify($.extend({}, state.data, {
                        isExpressPdp: self.isExpressPdp
                    }))
                }
            }).then(function (response) {
                if (typeof response === 'string') {
                    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                        'fade show" role="alert">' +
                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                        '<span aria-hidden="true">&times;</span>' +
                        // eslint-disable-next-line no-useless-concat
                        '</button>' + 'Your session has expired. For security, the page will reload. Please try again.' + '</div>';

                    $('.checkout-error').append(errorHtml);
                    try {
                        if (component && typeof component.unmount === 'function') {
                            component.unmount();
                        }
                    } catch (e) { /* ignore */ }
                    $('.express-checkout-card').remove();
                    setTimeout(function () {
                        window.location.reload();
                    }, 3000);
                    return;
                }
                var action = response.fullResponse && response.fullResponse.action;
                if (action) {
                    component.handleAction(action);
                } else {
                    component.handleError();
                }
            }).catch(function (e) {
                component.handleError(e);
            });
        });
    } catch (e) {
        component.handleError(e);
    }
};

Paypal.prototype.onAuthorized = function (data, actions) {
    var authorizedEvent = data.authorizedEvent;
    var payer = (authorizedEvent && authorizedEvent.payer) || {};
    var billingAddress = data.billingAddress;
    var deliveryAddress = data.deliveryAddress;
    var shopperDetails = {
        shopperEmail: payer.email_address,
        telephoneNumber: payer.phone && payer.phone.phone_number && payer.phone.phone_number.national_number,
        shopperName: {
            firstName: payer.name && payer.name.given_name,
            lastName: payer.name && payer.name.surname
        },
        shippingAddress: deliveryAddress,
        billingAddress: billingAddress,
        isExpressPdp: this.isExpressPdp
    };

    // Custom Peter Millar: Hazardous materials check for AK/HI states
    if (
        (deliveryAddress.stateOrProvince === 'AK' ||
            deliveryAddress.stateOrProvince === 'HI') &&
        $('#isHazardousProducts').val() === 'true'
    ) {
        sessionStorage.setItem('stateCodeFromApplePay', deliveryAddress.state);
        var pageAction = $('.page').data('action');
        var cartPageNavigationURL = $('#cartPageNavigation').val();

        if (pageAction && pageAction !== 'Checkout-Begin') {
            sessionStorage.setItem('applePayEmail', payer.email_address);
        }

        if (pageAction && pageAction !== 'Cart-Show' && pageAction !== 'Checkout-Begin' && cartPageNavigationURL) {
            location.assign(cartPageNavigationURL);
        } else {
            location.reload();
        }
        return Promise.reject();
    }
    return httpClient({
        method: 'POST',
        url: this.saveShopperDataUrl,
        data: {
            data: JSON.stringify(shopperDetails)
        }
    }).then(function () {
        actions.resolve();
    }).catch(function () {
        if ($.spinner) {
            $.spinner().stop();
        }
    });
};

Paypal.prototype.makeExpressPaymentDetailsCall = function (data) {
    var self = this;
    return httpClient({
        method: 'POST',
        url: this.makeExpressPaymentDetailsCallUrl,
        data: {
            data: JSON.stringify({ data: data, isExpressPdp: this.isExpressPdp })
        }
    }).then(function (response) {
        if (response.redirectUrl && response.error) {
            var redirectUrl = String(response.redirectUrl);
            var normalized = redirectUrl.toLowerCase().split('?')[0].split('#')[0];
            var isCart = /(^|\/)cart(\b|\/)/.test(normalized) || normalized.indexOf('cart-show') > -1;
            if (isCart) {
                window.location.href = response.redirectUrl;
                return Promise.reject();
            }
        }
        self.helpers.createShowConfirmationForm(self.showConfirmationAction);
        self.helpers.setOrderFormData(response);
        return null;
    }).catch(function (e) {
        if ($.spinner) {
            $.spinner().stop();
        }
        throw e;
    });
};

Paypal.prototype.onShippingAddressChange = function (data, actions, component) {
    var shippingAddress = data.shippingAddress;
    var currentPaymentData = component.paymentData;
    if (!shippingAddress) {
        return actions.reject();
    }
    var requestBody = {
        paymentMethodType: PAYPAL,
        currentPaymentData: currentPaymentData,
        isExpressPdp: this.isExpressPdp,
        address: {
            city: shippingAddress.city,
            country: shippingAddress.country,
            countryCode: shippingAddress.countryCode,
            stateCode: shippingAddress.state,
            postalCode: shippingAddress.postalCode
        }
    };
    return httpClient({
        method: 'POST',
        url: this.shippingMethodsUrl,
        data: {
            data: JSON.stringify(requestBody)
        }
    }).then(function (response) {
        Paypal.updateComponent(response, component);
        return null;
    }).catch(function () {
        return actions.reject(data.errors.ADDRESS_ERROR);
    });
};

Paypal.prototype.onShippingOptionsChange = function (data, actions, component) {
    var selectedShippingOption = data.selectedShippingOption;
    if (!selectedShippingOption) {
        return actions.reject();
    }
    return httpClient({
        method: 'POST',
        url: this.selectShippingMethodUrl,
        data: {
            data: JSON.stringify({
                paymentMethodType: PAYPAL,
                currentPaymentData: component.paymentData,
                methodID: selectedShippingOption.id,
                isExpressPdp: this.isExpressPdp
            })
        }
    }).then(function (response) {
        Paypal.updateComponent(response, component);
        return null;
    }).catch(function () {
        return actions.reject(data.errors.METHOD_UNAVAILABLE);
    });
};

Paypal.prototype.onAdditionalDetails = function (state, component) {
    var self = this;
    if (this.userAction) {
        return httpClient({
            method: 'POST',
            url: this.saveExpressPaymentDataUrl,
            data: {
                data: JSON.stringify($.extend({}, state.data, {
                    isExpressPdp: self.isExpressPdp
                }))
            }
        }).then(function (response) {
            if (response.success && response.redirectUrl) {
                window.location.href = response.redirectUrl;
            }
        }).catch(function (e) {
            component.handleError(e);
            if ($.spinner) {
                $.spinner().stop();
            }
        });
    }

    return this.makeExpressPaymentDetailsCall(state.data).then(function () {
        document.querySelector('#additionalDetailsHidden').value = JSON.stringify(state.data);
        document.querySelector('#showConfirmationForm').submit();
    });
};

Paypal.prototype.getConfig = function () {
    var config = {
        configuration: this.config,
        showPayButton: this.showPayButton,
        returnUrl: this.returnUrl,
        amount: this.amount,
        isExpress: this.isExpress,
        onSubmit: this.callPaymentFromComponent.bind(this),
        onError: Paypal.onError,
        onAuthorized: this.onAuthorized.bind(this),
        onAdditionalDetails: this.onAdditionalDetails.bind(this),
        onShippingAddressChange: this.onShippingAddressChange.bind(this),
        onShippingOptionsChange: this.onShippingOptionsChange.bind(this),
        blockPayPalCreditButton: true,
        blockPayPalPayLaterButton: true,
        blockPayPalVenmoButton: true,
        style: {
            height: 40,
            shape: 'sharp',
            color: 'white',
            disableMaxWidth: true
        }
    };
    if (this.userAction) {
        config.userAction = this.userAction;
    }
    return config;
};

Paypal.prototype.getComponent = function () {
    var self = this;


    return initializeCheckout(
        this.applicationInfo
    ).then(function (checkout) {
        var paypalConfig = self.getConfig();
        return window.AdyenWeb.createComponent(PAYPAL, checkout, paypalConfig);
    });
};

module.exports = Paypal;
